import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {DatePipe, NgClass, NgForOf, NgIf} from '@angular/common';
import {AuthenticationHelperService} from "../../../../../services/helpers/authentication-helper.service";
import {UserRoles} from "../../../../../enums/general-enums";
import {
  AListerMobilePlan,
  AListerPlan, CompanyMobilePlan, CompanyPlan,
  ExpertMobilePlan,
  ExpertPlan,
  FreePlan
} from "../../../../../constants/subscription-variables";
import {PaymentHttpService} from "../../../../../services/http-services/payment/payment-http.service";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'tl-subscription-plans',
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    NgForOf,
    TranslateModule,
    DatePipe
  ],
  templateUrl: './subscription-plans.component.html',
})
export class SubscriptionPlansComponent implements OnChanges {
  @Input() planId = '';
  @Input() currentPlan: any;
  @Output() clickOnPlan: EventEmitter<any> = new EventEmitter<any>();
  @Output() clickToSubscribeOnPlan: EventEmitter<any> = new EventEmitter<any>();
  @Output() clickToCancelSubscription: EventEmitter<void> = new EventEmitter<void>();
  selectedPlan: any;
  availablePlans: any[] = [];
  protected readonly UserRoles = UserRoles;
  constructor(private authHelperService: AuthenticationHelperService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    switch (changes.currentPlan.currentValue?.plan) {
      case FreePlan.planId: {
        this.selectedPlan = FreePlan;
        this.availablePlans = [AListerPlan, ExpertPlan];
        break;
      }
      case AListerMobilePlan.planId: {
        this.selectedPlan = AListerMobilePlan;
        this.availablePlans = [ExpertPlan];
        break;
      }
      case AListerPlan.planId: {
        this.selectedPlan = AListerPlan;
        this.availablePlans = [ExpertPlan];
        break;
      }
      case ExpertMobilePlan.planId: {
        this.selectedPlan = ExpertMobilePlan;
        this.availablePlans = [];
        break;
      }
      case ExpertPlan.planId: {
        this.selectedPlan = ExpertPlan;
        this.availablePlans = [];
        break;
      }
      case CompanyMobilePlan.planId: {
        this.selectedPlan = CompanyMobilePlan;
        this.availablePlans = [];
        break;
      }
      case CompanyPlan.planId: {
        this.selectedPlan = CompanyPlan;
        this.availablePlans = [];
        break;
      }
      default: {
        if (this.authHelperService.getUserData.company_profile === 1) {
          this.availablePlans = [CompanyPlan];
        } else {
          this.selectedPlan = FreePlan;
          this.availablePlans = [AListerPlan, ExpertPlan];
        }
      }
    }
  }

  handleSubscription(event: any, plan: any, isCancel = false): void {
    event.stopPropagation();
    if (isCancel) {
      this.clickToCancelSubscription.emit(plan);
    } else {
      this.clickToSubscribeOnPlan.emit(plan);
    }
  }
}
